import {Interval} from '@/modules/typedef'

export const basePrice = {
  [Interval.MONTH]: 100,
  [Interval.YEAR]: 75,
}
